<template>
  <div class="c-dmpsplit-wrapper">
    <!-- filter -->
    <split-filter slot="filter" @on-change="filterData" @on-add="openNew" />
    <!-- table -->
    <Viewport v-model="tableHeight">
      <el-table class="common-el-table-styles" ref="table" :data="tableData" :height="tableHeight" v-loading="loading">
        <el-table-column
          v-for="(col, id) in tableColumns"
          :key="id"
          :prop="col.key"
          :label="col.title"
          :fixed="col.fixed"
          :show-overflow-tooltip="col.overflow"
          :min-width="col.width"
          :align="col.align"
        >
          <template slot-scope="scope">
            <div v-if="col.key === 'control'" class="m-control">
              <el-button type="text" class="c-control-margin" @click="editClick(scope.row)">修改</el-button>
            </div>
            <span v-else-if="['imeiType', 'oaidType', 'idfaType'].includes(col.key)">{{ cellEqui(scope.row[col.key]) }}</span>
            <span v-else-if="col.key === 'docType'">{{ cellDoctype(scope.row[col.key]) }}</span>
            <span v-else-if="col.key === 'transform'">{{ cellTrans(scope.row[col.key]) }}</span>
            <span v-else-if="['maxNum', 'minNum', 'maxCapacity'].includes(col.key)">{{ scope.row[col.key] | toThousands }}</span>
            <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
            <span v-else>{{ scope.row[col.key] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <Page
        show-total
        show-sizer
        show-elevator
        class="c-table-page pager"
        size="small"
        :total="total"
        :current.sync="pageIndex"
        :page-size="pageSize"
        :page-size-opts="[10, 20, 30, 40, 100]"
        @on-change="changePageIndex"
        @on-page-size-change="changePageSize"
      />
    </Viewport>
    <!-- 弹出框 -->
    <set-split
      v-model="model"
      title="分包参数设置"
      :loading="saving"
      :equi-data="equiData"
      :doctype-data="doctypeData"
      :trans-data="transData"
      :edit="edit"
      :info="info"
      @on-save="saveSplit"
    />
  </div>
</template>
<script>
import { isArray, isEmpty, timeout } from '@/common/js/utils'
import mixin from '../mixins/mixin'
import mixinPage from '../mixins/mixin_page'
import tableColumns from '../data/split_columns'
import SplitFilter from './components/split-filter'
import SetSplit from './components/set-split'

import { dmpSubPackageConfigPage, getSubPackageConfig, addSubPackageConfig } from '@/api/manage.model'

export default {
  name: 'DMPush',
  mixins: [mixin, mixinPage],
  components: { SplitFilter, SetSplit },
  data() {
    return {
      saving: null,
      loading: null,
      edit: null,
      model: null,
      tableHeight: 330,
      tableData: [],
      tableColumns: [],
      info: {},
      equiData: [
        { id: 1, name: '原值32MD5' },
        { id: 2, name: '大写32MD5' },
        { id: 3, name: '小写32MD5' },
        { id: 4, name: '原值' }
      ],
      doctypeData: [
        { id: 1, name: 'TXT' },
        { id: 2, name: 'ZIP' }
      ],
      transData: [
        { id: 1, name: '小写MD5值' },
        { id: 2, name: '大写MD5值' }
      ]
    }
  },
  created() {
    this.filterData({})
  },
  methods: {
    cellEqui(cell) {
      if (isEmpty(cell)) return ''
      else return this.equiData.filter((ret) => ret.id === cell).pop().name
    },
    cellDoctype(cell) {
      if (isEmpty(cell)) return ''
      else return this.doctypeData.filter((ret) => ret.id === cell).pop().name
    },
    cellTrans(cell) {
      if (isEmpty(cell)) return ''
      else return this.transData.filter((ret) => ret.id === cell).pop().name
    },
    editClick(row) {
      if (!row || !row.id) return
      this.id = row.id
      getSubPackageConfig({ id: this.id }).then((data) => {
        if (typeof data !== 'symbol') {
          this.info = data
          this.model = true
          this.edit = true
          this.id = undefined
        }
      })
    },
    openNew() {
      this.info = {
        mediaId: '',
        idfaType: 1,
        imeiType: 1,
        oaidType: 1,
        docType: 1,
        transform: 1
      }
      this.model = true
      this.edit = false
    },
    saveSplit(info) {
      if (this.edit && this.id) Object.assign(info, { id: this.id })
      this.saving = true
      addSubPackageConfig(info).then((data) => {
        if (typeof data !== 'symbol') {
          this.saving = false
          this.model = false
          timeout(0).then(() => {
            this.edit = null
            this.id = undefined
          })
          this.getData({})
        }
      })
    },
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      dmpSubPackageConfigPage(params)
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            if (!data) return
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              this.tableColumns = tableColumns
              this.tableData = list
              this.total = total_number || 0
            } else {
              this.tableColumns = []
              this.tableData = []
              this.total = 0
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.tableData = []
          this.tableColumns = []
          this.total = 0
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-dmpsplit-wrapper {
  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
